import { render } from "./NestlyPrivacyPolicy.vue?vue&type=template&id=6fc83bca&scoped=true"
import script from "./NestlyPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./NestlyPrivacyPolicy.vue?vue&type=script&lang=js"

import "./NestlyPrivacyPolicy.vue?vue&type=style&index=0&id=6fc83bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc83bca"]])

export default __exports__